import PropTypes from 'prop-types';

export default PropTypes.oneOf(['EN', 'FR', 'NL']);
